<template>
<v-row class="im-result" no-gutters align="center">
    <v-col cols="2" md="1" class="px-2">
        <div>
            {{item.id}}
        </div>
    </v-col>
    <v-col cols="10" md="3" class="px-2">
        <div>
            {{item.service}}
        </div>
    </v-col>
    <v-col cols="12" md="3" class="px-2">
        <div :class="{'pt-2': $vuetify.breakpoint.xs}">
            {{item.path}}
        </div>
    </v-col>
    <v-col cols="12" md="5" class="px-2">
        <v-row no-gutters align="center" :class="{'pt-2': $vuetify.breakpoint.xs}">
            <v-chip v-for="(id, index) in item.events" :small="$vuetify.breakpoint.smAndDown" :class="{'detail': $vuetify.breakpoint.smAndDown, 'ma-1':true}" :key="index">
                {{filteredEvents(id)}}
            </v-chip>
        </v-row>
    </v-col>
</v-row>
</template>

<script>
export default {
    props: {
        item: Object,
        events: Array,
    },
    methods: {
        emitClick() {
            this.$emit('click');
        },
        filteredEvents: function (id) {
            let events = this.events.filter((item) => {
                if(item.value === id) return item;
            });
            return events.length > 0 ? events[0].text : null;
        }
    },
    data() {
        return {}
    }
}
</script>
